import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

export default function UserShortRedirect() {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const raw = String(code || "").trim();
    const id = parseInt(raw, 36);

    if (Number.isFinite(id) && id > 0) {
      navigate(`/users/${id}`, { replace: true });
    } else {
      navigate("/users", { replace: true });
    }
  }, [code, navigate]);

  return null;
}
